import { DadosCienciaProfissional } from "../../types";
import { TableContainer } from "../../styles";

interface BlocoPrincipalProps {
    dados: DadosCienciaProfissional;
}

const formatarValor = (valor: string): string => {
    if (!valor) {
        return "—";
    }

    return valor;
};

export default function BlocoPrincipal({ dados }: BlocoPrincipalProps) {
    return (
        <div className="expanded-section">
            <h4 className="section-title">Principal</h4>

            <TableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className="field-cell">Status da ciência</td>
                            <td className="before-cell">{formatarValor(dados.statusCienciaAntes)}</td>
                            <td className="after-cell">{formatarValor(dados.statusCienciaDepois)}</td>
                        </tr>
                    </tbody>
                </table>
            </TableContainer>
        </div>
    );
}


